import {
    SET_PROPERTY_CONTACTS,
    UPDATE_PROPERTY_CONTACTS,
    SET_PROPERTY_FIELDS
} from "../../types";
import { setAlert } from "../alert";

//	DESC: Empty contact object
const emptyContact = {
    address1: "",
    address2: "",
    city: "",
    comments: "",
    contact_id: "",
    created_at: "",
    created_by: "",
    deleted_at: "",
    deleted_by: "",
    disabled: "",
    name: "",
    email: "",
    fax_country: "",
    fax_number: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    mobile_country: "",
    mobile_number: "",
    organization: "",
    organization_id: 11,
    phone_country: "",
    phone_number: "",
    phone: "",
    state: "",
    title: "",
    type: "",
    updated_at: "",
    updated_by: "",
    zip: ""
};

//  setContacts function will be called from properties "getPropertyAssets"
//  the purpose is format and create a new contacts object that will works with the UI
//  this function DOES NOT denpends on updateContacts to acuatlly update the contacts object

export const setContacts = () => async(dispatch, getState) => {
    try {
        const { properties: { propertyData: { contactTypes, contacts } } } = getState();

        /**
         * Map through the contacts object and set to the correct
         * data format for backend processing
         */
        const newContacts = contactTypes.map(type => {
            const contact = { ...contacts[type.id] };
            contact.contact_id = contact.id;
            delete contact.id;
            return {
                ...type,
                ...contact
            };
        });

        await dispatch({
            type: SET_PROPERTY_CONTACTS,
            payload: newContacts
        });
        dispatch(updateContactData(newContacts));
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

//  This updateContacts function handles update amenities object
//  It will be called from properties action "updatePropertyFields"

export const updateContacts = event => async(dispatch, getState) => {
    try {
    //	@TODO: Write explanation for this function
    // DESC: Pull contacts and contactTypeDropdown from gobal state. contactTypeDropdown is generated from back-end. A contact list will ties to a specific contact type.
        const {
            propertyContacts: { contacts },
            properties: { propertyData: { contactTypeDropdown } }
        } = getState();

        //	DESC:  	A set of contacts is preset at setContacts method. setContact method is set when application is loaded.
        //	DESC: 	method maps through contacts and find the right contact using target name and target id.
        const newContacts = contacts.map(contact => {
            //	Find the correct contact Type
            if (String(contact.id) === event.target.name) {
                //	Go deeper and find the contact
                let contactObj = Object.values(
                    contactTypeDropdown[event.target.name]
                ).find(user => String(user.id) === event.target.value);
                console.debug({
                    msg: "[SELECTED CONTACT]",
                    contactObj
                });

                //	create a new person object to use for spreading.
                // 	replace replace id property with contact_id property because this person object will merge with the contact type. Therefore, it will override the contact type id.
                const person = Object.assign({}, contactObj);
                person.contact_id = person.id;
                delete person.id;
                //	Checking empty contact when user select blank. This will remove all their contact info on client side
                //	ATTN: This method will stop after this return
                if (!person.contact_id) {
                    return {
                        ...contact,
                        ...emptyContact
                    };
                }
                //	return a merge object of contact type and contact
                return {
                    ...contact,
                    ...person,
                    phone_number: person.phone ||
                        person.mobile_number ||
                        person.phone_number ||
                        "Phone Number Not Found!",
                    name: person.first_name + " " + person.last_name
                };
            }
            return contact;

        });
        await dispatch({
            type: UPDATE_PROPERTY_CONTACTS,
            payload: newContacts
        });
        dispatch(updateContactData(newContacts));
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

export const updateContactData = contacts => async(dispatch, getState) => {
    try {
    //	DESC: GET propertyFields and make a copy of it
        const { properties: { propertyFields } } = getState();
        let newPropertyFields = { ...propertyFields };

        const newContacts = [...contacts];

        //	DESC: mapp through contacts - formatted in propertyContact -
        newContacts.forEach(contact => {
            // if (!contact.contact_id) return;
            switch (contact.id) {
                case 1: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["appraiser1-name"]: contact.name,
                        ["appraiser1-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["appraiser1-organization"]: contact.organization,
                        ["appraiser1-email"]: contact.email,
                        ["appraiser1-address1"]: contact.address1,
                        ["appraiser1-city"]: contact.city,
                        ["appraiser1-state"]: contact.state,
                        ["appraiser1-zip"]: contact.zip
                    };
                    break;
                }
                case 2: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["appraiser2-name"]: contact.name,
                        ["appraiser2-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["appraiser2-organization"]: contact.organization,
                        ["appraiser2-email"]: contact.email,
                        ["appraiser2-address1"]: contact.address1,
                        ["appraiser2-city"]: contact.city,
                        ["appraiser2-state"]: contact.state,
                        ["appraiser2-zip"]: contact.zip
                    };
                    break;
                }
                case 3: {
                    const { contact_id, organization_id } = contact;
                    const ColliersID = 43;

                    newPropertyFields = {
                        ...newPropertyFields,
                        marketing_affiliated_broker: contact_id && organization_id === ColliersID ?
                            "Y" :
                            "N",
                        ["broker-name"]: contact.name,
                        ["broker-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["broker-organization"]: contact.organization,
                        ["broker-email"]: contact.email,
                        ["broker-address1"]: contact.address1,
                        ["broker-city"]: contact.city,
                        ["broker-state"]: contact.state,
                        ["broker-zip"]: contact.zip
                    };
                    break;
                }
                case 4: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["environmental-consultant-name"]: contact.name,
                        ["environmental-consultant-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["environmental-consultant-organization"]: contact.organization,
                        ["environmental-consultant-email"]: contact.email
                    };
                    break;
                }
                case 5: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["client-account-officer-name"]: contact.name
                    };
                    break;
                }
                case 6: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["land-surveyor-name"]: contact.name,
                        ["land-surveyor-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["land-surveyor-organization"]: contact.organization,
                        ["land-surveyor-email"]: contact.email
                    };

                    break;
                }

                case 8: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["property-manager-name"]: contact.name,
                        ["property-manager-phone"]: contact.mobile_number ||
                            contact.phone_number ||
                            contact.phone,
                        ["property-manager-organization"]: contact.organization,
                        ["property-manager-organization-phone"]: contact.phone_number ||
                            contact.phone ||
                            contact.mobile_number,
                        ["property-manager-email"]: contact.email
                    };
                    break;
                }

                case 10: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["title-specialist-clearing-name"]: contact.name,
                        ["title-specialist-clearing-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["title-specialist-clearing-organization"]: contact.organization,
                        ["title-specialist-clearing-email"]: contact.email
                    };
                    break;
                }
                case 13: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["asset-manager-name"]: contact.name,
                        ["asset-manager-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["asset-manager-organization"]: contact.organization,
                        ["asset-manager-email"]: contact.email
                    };
                    break;
                }
                case 15: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["client-account-officer-name"]: contact.name
                    };
                    break;
                }
                case 16: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["environmental-specialist-name"]: contact.name,
                        ["environmental-specialist-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["environmental-specialist-organization"]: contact.organization,
                        ["environmental-specialist-email"]: contact.email
                    };
                    break;
                }
                case 21: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["legal_outside_counsel_retained"]: contact.contact_id ?
                            "Y" :
                            "N",
                        ["legal-outside-counsel-name"]: contact.name,
                        ["legal-outside-counsel-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["legal-outside-counsel-organization"]: contact.organization,
                        ["legal-outside-counsel-email"]: contact.email,
                        ["legal-outside-counsel-address1"]: contact.address1,
                        ["legal-outside-counsel-city"]: contact.city,
                        ["legal-outside-counsel-state"]: contact.state,
                        ["legal-outside-counsel-zip"]: contact.zip
                    };
                    break;
                }

                case 24: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["title-specialist-closing-name"]: contact.name,
                        ["title-specialist-closing-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["title-specialist-closing-organization"]: contact.organization,
                        ["title-specialist-closing-email"]: contact.email
                    };
                    break;
                }
                case 25: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["property-operations-manager-name"]: contact.name,
                        ["property-operations-manager-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["property-operations-manager-organization"]: contact.organization,
                        ["property-operations-manager-email"]: contact.email
                    };
                    break;
                }

                case 26: {
                    newPropertyFields = {
                        ...newPropertyFields,
                        ["title-manager-name"]: contact.name,
                        ["title-manager-phone"]: contact.mobile_number ||
                            contact.phone ||
                            contact.phone_number,
                        ["title-manager-organization"]: contact.organization,
                        ["title-manager-email"]: contact.email
                    };
                    break;
                }
                default:
                    break;
            }
        });
        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};